if (customElements && !customElements.get('content-showcase')) {
  class ContentShowcase extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.lineTl) return;
      this.init();
    }

    disconnectedCallback() {
      queueMicrotask(() => { if (!this.isConnected) this.destroy(); });
    }

    destroy() {
      if (this.lineTl) {
        if (this.lineTl.scrollTrigger) this.lineTl.scrollTrigger.kill(true);
        this.lineTl.kill();
      }
      this.lineTl = undefined;
    }

    initAnimateLineIcon() {
      if (typeof ScrollTrigger === 'undefined') {
        console.error('Not found GSAP Plugin. ScrollTrigger');
        return;
      }

      const container = this.querySelector('[data-role="layout-holder"]');
      if (!container) return;

      const layoutBlocks = container.children;

      const iconLine = this.querySelector('[data-role="icon-line"] svg');
      if (!iconLine) return;

      const durationScroll = layoutBlocks.length > 1 ? layoutBlocks.length - 1 : 1;

      const tl = this.lineTl = gsap.timeline({
        scrollTrigger: {
          id: 'line-content-showcase',
          scrub: true,
          trigger: container,
          start: 'top top',
          end: 'bottom bottom',
          invalidateOnRefresh: true
        }
      });

      // Init base duration timeline
      tl.set({}, {}, durationScroll);


      // Setup iconLine animation
      tl.set(iconLine,
        {
          clipPath: 'inset(0 0 100% 0)',
          immediateRender: true,
        },
        0
      );

      tl.fromTo(iconLine,
        {
          clipPath: 'inset(0 0 70% 0)'
        },
        {
          clipPath: 'inset(0 0 30% 0)',
          ease: 'none',
          immediateRender: false,
          duration: 0.6,
          onUpdate: function() {
            // console.log(this.time().toFixed(3));
          }
        },
        ">"
      );
    }

    initAnimate() {
      if (typeof gsap === 'undefined') {
        console.error('Not found: GSAP');
        return;
      }

      this.initAnimateLineIcon();
    }

    init() {
      this.initAnimate();
    }
  }

  customElements.define('content-showcase', ContentShowcase);
}